import { createReducer } from 'typesafe-actions';
import actions, { QuestionnairesAction } from './actions';
import { QuestionnairesState } from './types';

export const initSearchState: QuestionnairesState = {};

const reducer = createReducer<QuestionnairesState, QuestionnairesAction>(
  initSearchState,
)
  .handleAction(actions.fetch.request, (state) => ({
    ...state,
    isFetching: true,
  }))
  .handleAction(actions.fetch.failure, (state, { payload }) => ({
    ...state,
    isFetching: false,
    fetchError: payload,
  }))
  .handleAction(actions.fetch.success, (state, { payload }) => ({
    ...state,
    isFetching: false,
    hasFetched: true,
    questionnaires: payload,
  }))
  .handleAction(actions.getRevision.request, (state) => ({
    ...state,
    isFetching: true,
  }))
  .handleAction(actions.getRevision.failure, (state, { payload }) => ({
    ...state,
    isFetching: false,
    fetchError: payload,
  }))
  .handleAction(actions.getRevision.success, (state, { payload }) => ({
    ...state,
    isFetching: false,
    hasFetched: true,
    questionnaires: [...(state.questionnaires || []), payload],
  }))
  .handleAction(actions.questionnaireStatusChange, (state, { payload }) => {
    if (!state.questionnaires) return state;
    const recIndex = state.questionnaires.findIndex((i) => i.id === payload.id);

    let updatedList = [...state.questionnaires.slice(0, recIndex)];

    if (!payload.deleted) updatedList.push(payload);

    updatedList = updatedList.concat(state.questionnaires.slice(recIndex + 1));

    return {
      ...state,
      questionnaires: updatedList,
    };
  });

export default reducer;
